import React from 'react';
import { BoltIcon, ChatBubbleBottomCenterTextIcon, GlobeAltIcon, ScaleIcon } from '@heroicons/react/24/outline'

const features = [
  {
    name: 'Write a Press Release',
    description:
      'There are specific guidelines for writing a press release—covering everything from news angles to press release structure. All of them you will find in our complete guide on how to write press releases that get attention (and results!), along with expert comments.',
    icon: GlobeAltIcon,
  },
  {
    name: 'Proofreading',
    description:
      'Proofreading means carefully checking for errors in a text before it is published or shared. It is the very last stage of the writing process, when you fix minor spelling and punctuation mistakes, typos, formatting issues and inconsistencies.',
    icon: ScaleIcon,
  },
  {
    name: 'Researching Articles',
    description:
      'Journalistic research is multi-faceted, involving online searching, poring over data, records, surveys, and polls; phone calls with sources, experts, and officials; in-person formal interviews, visiting libraries and archives; and the old school way—pounding the streets and talking to contacts.',
    icon: BoltIcon,
  },
  {
    name: 'Reading a Press Release',
    description:
      'There are specific guidelines for reading a press release—covering everything from news angles to press release structure. All of them you will find in our complete guide on how to write press releases that get attention (and results!), along with expert comments.',
    icon: ChatBubbleBottomCenterTextIcon,
  },
]

const InformationContent = () => {
    return (
        <div className="bg-white py-12 my-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-lg font-semibold text-indigo-600">Journalism</h2>
          <p className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
          What does a journalist do?
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
          Journalists write and assemble together news stories that will interest their audience. By gathering together a number of different sources and ensuring that all the arguments are represented, they keep their audience abreast of events in their world.
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10 md:space-y-0">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-indigo-500 text-white">
                    <feature.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg font-medium leading-6 text-gray-900">{feature.name}</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
    );
};

export default InformationContent;